import React from 'react';

const EmptyState = ({ icon, title, description, buttonLabel, onButtonClick, className, loader }) => {
  return (
    <div className={`flex flex-col items-center justify-center text-center ${icon === "" ? "py-8" : "py-16"} ${className || ''}`}>
      {icon !== "" && (
        <>
          <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6">
            {icon}
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
          <p className="text-gray-600 max-w-md mb-8">{description}</p>
        </>
      )}
      {buttonLabel && onButtonClick && (
        <button
          onClick={onButtonClick}
          disabled={loader}
          className={`text-white px-4 py-2 lg:min-w-[300px] rounded-md ${loader ? "bg-[#2962ff71] cursor-not-allowed" : "bg-[#2962FF] hover:bg-[#2962FF]/90 cursor-pointer"}`}
        >
          {buttonLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
